import script from "./ReadingActionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadingActionsMenu.vue?vue&type=script&setup=true&lang=js"

import "./ReadingActionsMenu.vue?vue&type=style&index=0&id=ac991584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac991584"]])

export default __exports__